import { AppConfig } from '@/config/config'

export default {
  methods: {
    formatDocumentUploadUrl (profile) {
      return `document-storage2/api/admin/v1/files/${profile.id}/upload/CLIENT_REQUESTS`
    },
    formatDocumentUrl (profile, documentId) {
      if (documentId == null) {
        return
      }

      return `${AppConfig.GATEWAY_DOCUMENT_STORAGE2_URL}/api/admin/v1/files/${profile.id}/download/${documentId}`
    },
    formatDocumentArchiveUrl (profile, documentIds) {
      const documentsQuery = documentIds.join('&documents=')

      return `${AppConfig.GATEWAY_DOCUMENT_STORAGE2_URL}/api/admin/v1/files/${profile.id}/download/archive?documents=${documentsQuery}`
    }
  }
}
